import { render, staticRenderFns } from "./TextResult.vue?vue&type=template&id=1f3dd2fe"
import script from "./TextResult.vue?vue&type=script&lang=js"
export * from "./TextResult.vue?vue&type=script&lang=js"
import style0 from "./TextResult.vue?vue&type=style&index=0&id=1f3dd2fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports